import React, { Component } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Table, Button, Divider, Modal } from 'antd';
import { QuestionCircleFilled } from '@ant-design/icons';
import FormModal from './FormModal';
import { getPaginationConfig } from '../../../components/pagination';
import { PAGE_SIZE_DEFAULT } from '../../../constants/appConstant';
const { confirm } = Modal;
@inject('approvePermissionStore','permissionManagementStore')
@observer
class SearchResult extends Component {
  state={
    addModalVisible: false,
    record: null
  }
  componentDidMount() {
    const { approvePermissionStore } = this.props;
    const {searchItem} = approvePermissionStore
    approvePermissionStore.onSearchApproveAction(searchItem,1,PAGE_SIZE_DEFAULT)
  }
  handleAgree=(record)=>{
    const { approvePermissionStore } = this.props;
    confirm({
      title: 'Approve Data',
      icon: <QuestionCircleFilled />,
      content: 'Are you sure to agree with this application ?',
      okText: 'Agree',
      cancelText: 'Cancel',
      onOk() {
        approvePermissionStore.onAgreeAction({
          "description": '',
          "id": record.id,
          "status": 1
        });
      },
      onCancel() {
        console.log('Cancel');
      },
    })
    return false;
  }
  handleRefuse=(record)=>{
    this.setState({
      addModalVisible: true,
      record: record
    })
  }
  handleCancel=()=>{
    this.setState({
      addModalVisible: false
    })
  }
  handlePageChange = (page, pageSize) => {
    const { approvePermissionStore } = this.props
    approvePermissionStore.onChangePageNumAction(page, pageSize || 10)
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }
  render() {
    const { approvePermissionStore } = this.props
    const { approveList, pageNo, pageSize, itemCount } = approvePermissionStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange);
      return (
        <>
          <Table className='searchResult' dataSource={toJS(approveList)} rowKey="id" pagination={pagination} rowClassName={this.getRowClassName} bordered>
            <Table.Column title='User Name' dataIndex="applicant" key="applicant" ellipsis={true} />
            <Table.Column title='Role Name' dataIndex="roleNames" key="roleNames" ellipsis={true} />
            <Table.Column title='Approve Reason' dataIndex="reason" key="reason" ellipsis={true}  />
            <Table.Column title='Status' dataIndex="statusName" key="statusName" />
            <Table.Column title='Apply Date' dataIndex="createdTime" key="createdTime"/>
            <Table.Column title='Approve Date' dataIndex="approvalTime" key="approvalTime"/>
            <Table.Column width={150} align='center' title="Action" key="Action" render={(text, record) => (
                <>
                  <Button onClick={() => this.handleAgree(record)} type='link' title='Agree' disabled={record.status!==0}>Agree</Button>
                  <Divider type="vertical" />
                  <Button onClick={() => this.handleRefuse(record)} type='link' title='Refuse' disabled={record.status!==0}>Refuse</Button>
                </>
            )}/>
          </Table>
          {this.state.addModalVisible?<FormModal
            addModalVisible={this.state.addModalVisible}
            handleCancel={this.handleCancel}
            record={this.state.record}
          />:null}
        </>
      );
  }
}

export default SearchResult;
